export const USER_KEY = 'user'
export const MOCK_API = 'mockAPI'
export const TOKEN = 'token'
